module.exports = __webpack_public_path__ + "img/Syrenis-red.b1207926.svg";